<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">MAR-linking</h2>
    </div>

    <div class="modal-body">
        <p class="sectiontitle sectiontitle--first">MAR rekeningnummers</p>
        <small class="text-muted d-block m-b-3">Alle rekeningnummers uit het MAR-stelsel (GetGLAccountScheme) met koppeling naar overhead cost.</small>

        <div class="form-group m-b-2 mar-linking-search">
            <label>Zoek op rekeningnummer of omschrijving</label>
            <input
                class="input"
                type="text"
                [(ngModel)]="accountSearchTerm"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Bijv. 61 of verzekeringen" />
        </div>

        <div class="form-group--toggle m-b-2 mar-linking-toggle">
            <label (click)="toggleShowLinkedOnly()"
                ><span class="toggle" [ngClass]="showLinkedOnly ? 'toggle--active' : ''"></span>
                Toon enkel gelinkte rekeningen</label
            >
        </div>

        <div class="m-b-2 mar-ai-actions">
            <button type="button" class="button button--outline" (click)="generateAiLinkProposals()" [disabled]="aiLinkingLoading || aiApplying || loading">
                {{ aiLinkingLoading ? 'AI voorstellen laden...' : 'Link with AI' }}
            </button>
        </div>

        <div class="mar-ai-preview m-b-3" *ngIf="aiProposals.length > 0">
            <p class="sectiontitle m-b-1">AI voorstel (preview)</p>
            <small class="text-muted d-block m-b-2">Controleer deze koppelingen. Pas na klikken op Apply worden ze effectief opgeslagen.</small>

            <div class="table__overflow mar-ai-preview-list">
                <table class="table-view">
                    <tr>
                        <th>Overhead cost</th>
                        <th>Voorstel rekening</th>
                        <th>Confidence</th>
                    </tr>
                    <tr *ngFor="let proposal of aiProposals">
                        <td>{{ proposal.overheadCategoryName }}</td>
                        <td>
                            <strong>{{ proposal.accountNumber }}</strong>
                            <span class="text-muted"> - {{ proposal.accountName }}</span>
                        </td>
                        <td>{{ proposal.confidence !== null ? (proposal.confidence * 100 | number: '1.0-0') + '%' : '-' }}</td>
                    </tr>
                </table>
            </div>

            <div class="m-t-2 d-flex align-items-center">
                <button type="button" class="button" (click)="applyAiLinkProposals()" [disabled]="aiApplying || aiLinkingLoading">
                    {{ aiApplying ? 'Applying...' : 'Apply' }}
                </button>
                <small class="text-muted m-l-2">{{ aiProposals.length }} voorstel(len)</small>
            </div>
        </div>

        <ng-container *ngIf="!loading; else loadingTemplate">
            <div class="table__overflow mar-linking-list" *ngIf="filteredMarAccounts.length > 0; else noAccounts">
                <table class="table-view">
                    <tr>
                        <th>Rekeningnummer</th>
                        <th>Omschrijving</th>
                        <th>Overhead cost</th>
                    </tr>
                    <tr *ngFor="let account of filteredMarAccounts">
                        <td>
                            <strong>{{ account.accountNumber || '-' }}</strong>
                        </td>
                        <td>
                            {{ account.accountName || '-' }}
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <select class="input mar-linking-select"
                                        [(ngModel)]="account.overheadCategoryId"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="savingByAccountNumber[getAccountKey(account)]"
                                        (ngModelChange)="onOverheadCategorySelected(account, $event)">
                                    <option value="">-- Niet gekoppeld --</option>
                                    <option *ngFor="let category of overheadCategories" [value]="getCategoryId(category)">{{ category.categoryName }}</option>
                                </select>
                                <span class="m-l-1" *ngIf="savingByAccountNumber[getAccountKey(account)]">
                                    <app-loading-message></app-loading-message>
                                </span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </ng-container>

        <ng-template #noAccounts>
            <app-message-empty [title]="showLinkedOnly ? 'Geen gelinkte MAR rekeningnummers gevonden.' : 'Geen MAR rekeningnummers gevonden.'" [icon]="'../../assets/img/open-box.png'"></app-message-empty>
        </ng-template>

        <div class="m-t-4">
            <p class="sectiontitle">Nog niet gelinkte overheadkosten</p>
            <small class="text-muted d-block m-b-2">Deze overheadkosten komen niet uit Yuki en hebben nog geen koppeling met een MAR rekeningnummer.</small>

            <ng-container *ngIf="unlinkedOverheadCategories.length > 0; else noUnlinkedOverheadCosts">
                <small class="text-muted d-block m-b-1">{{ unlinkedOverheadCategories.length }} overheadkosten nog te linken</small>
                <div class="table__overflow mar-linking-unlinked-list">
                    <table class="table-view">
                        <tr>
                            <th>Overhead cost</th>
                        </tr>
                        <tr *ngFor="let category of unlinkedOverheadCategories">
                            <td>{{ category.categoryName || category.displayName || '-' }}</td>
                        </tr>
                    </table>
                </div>
            </ng-container>

            <ng-template #noUnlinkedOverheadCosts>
                <small class="text-muted d-block">Alle overheadkosten zijn gelinkt aan een MAR rekeningnummer.</small>
            </ng-template>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Close</button>
    </div>
</div>

<ng-template #loadingTemplate>
    <app-loading-message></app-loading-message>
</ng-template>
